export default __webpack_public_path__ + "static/media/volleyball-icon.e74856e8.svg";